export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";